import { render, staticRenderFns } from "./AddonDialog.vue?vue&type=template&id=878f1dba&scoped=true"
import script from "./AddonDialog.vue?vue&type=script&lang=js"
export * from "./AddonDialog.vue?vue&type=script&lang=js"
import style0 from "./AddonDialog.vue?vue&type=style&index=0&id=878f1dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878f1dba",
  null
  
)

export default component.exports